import { Decorators } from "../../Decorators";

export interface ScriptContext {
}

@Decorators.registerClass('Serenity.ScriptContext')
export class ScriptContext {
}